import { render, staticRenderFns } from "./ReportDisaster.vue?vue&type=template&id=d8955318"
import script from "./ReportDisaster.vue?vue&type=script&lang=js"
export * from "./ReportDisaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports